var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "17",
        viewBox: "0 0 20 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.5 0.518005C5.16304 0.518005 5.79893 0.781397 6.26777 1.25024C6.73661 1.71908 7 2.35496 7 3.01801C7 3.68105 6.73661 4.31693 6.26777 4.78577C5.79893 5.25461 5.16304 5.51801 4.5 5.51801C3.83696 5.51801 3.20107 5.25461 2.73223 4.78577C2.26339 4.31693 2 3.68105 2 3.01801C2 2.35496 2.26339 1.71908 2.73223 1.25024C3.20107 0.781397 3.83696 0.518005 4.5 0.518005ZM16 0.518005C16.663 0.518005 17.2989 0.781397 17.7678 1.25024C18.2366 1.71908 18.5 2.35496 18.5 3.01801C18.5 3.68105 18.2366 4.31693 17.7678 4.78577C17.2989 5.25461 16.663 5.51801 16 5.51801C15.337 5.51801 14.7011 5.25461 14.2322 4.78577C13.7634 4.31693 13.5 3.68105 13.5 3.01801C13.5 2.35496 13.7634 1.71908 14.2322 1.25024C14.7011 0.781397 15.337 0.518005 16 0.518005ZM0 9.85238C0 8.01176 1.49375 6.51801 3.33437 6.51801H4.66875C5.16562 6.51801 5.6375 6.62738 6.0625 6.82113C6.02187 7.04613 6.00313 7.28051 6.00313 7.51801C6.00313 8.71176 6.52812 9.78363 7.35625 10.518C7.35 10.518 7.34375 10.518 7.33437 10.518H0.665625C0.3 10.518 0 10.218 0 9.85238ZM12.6656 10.518C12.6594 10.518 12.6531 10.518 12.6438 10.518C13.475 9.78363 13.9969 8.71176 13.9969 7.51801C13.9969 7.28051 13.975 7.04926 13.9375 6.82113C14.3625 6.62426 14.8344 6.51801 15.3313 6.51801H16.6656C18.5063 6.51801 20 8.01176 20 9.85238C20 10.2211 19.7 10.518 19.3344 10.518H12.6656ZM7 7.51801C7 6.72236 7.31607 5.95929 7.87868 5.39669C8.44129 4.83408 9.20435 4.51801 10 4.51801C10.7956 4.51801 11.5587 4.83408 12.1213 5.39669C12.6839 5.95929 13 6.72236 13 7.51801C13 8.31365 12.6839 9.07672 12.1213 9.63933C11.5587 10.2019 10.7956 10.518 10 10.518C9.20435 10.518 8.44129 10.2019 7.87868 9.63933C7.31607 9.07672 7 8.31365 7 7.51801ZM4 15.6836C4 13.3836 5.86562 11.518 8.16562 11.518H11.8344C14.1344 11.518 16 13.3836 16 15.6836C16 16.143 15.6281 16.518 15.1656 16.518H4.83437C4.375 16.518 4 16.1461 4 15.6836Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }